const clamp = (value: number, min: number, max: number): number =>
    Math.max(Math.min(value, max), min);

export default Object.freeze({
    clamp,
});
